/*
 * File per la definizione delle direttive Angular:
 * https://code.angularjs.org/1.5.8/docs/guide/directive
 */
define([
    'angular',
    'file-saver'
],
function (angular, fileSaver) {
    var pageDirectives = angular.module('pageDirectives', []);

    pageDirectives.directive('pageHeader', ['$sce', 'CONSTANTS', pageHeader]);
    pageDirectives.directive('pageFooter', ['$sce', 'CONSTANTS', pageFooter]);
    pageDirectives.directive('richiedente', ['$sce', 'CONSTANTS', 'CFService', richiedente]);
    pageDirectives.directive('rappresentante', ['$sce', 'CONSTANTS', rappresentante]);
    pageDirectives.directive('sede', ['$sce', 'CONSTANTS', sede]);
    pageDirectives.directive('delega', ['$sce', 'CONSTANTS', delega]);
    pageDirectives.directive('naturaEnte', ['$sce', 'CONSTANTS', naturaEnte]);
    pageDirectives.directive('normeLegittimanti', ['$sce', 'CONSTANTS', normeLegittimanti]);
    pageDirectives.directive('responsabileConvenzione', ['$sce', 'CONSTANTS', responsabileConvenzione]);
    pageDirectives.directive('ricerca', ['$sce', 'CONSTANTS', ricerca]);
    pageDirectives.directive('variazioneDati', ['$sce', 'CONSTANTS', variazioneDati]);
    pageDirectives.directive('scaricaPdfRichiesta', ['$sce', 'CONSTANTS', scaricaPdfRichiesta]);
    pageDirectives.directive('annullaRichiestaVariazione', ['$sce', 'CONSTANTS', annullaRichiestaVariazione]);
    pageDirectives.directive('fieldValidation', ['$sce', 'CONSTANTS', fieldValidation]);
    pageDirectives.directive('validazioneForm', ['$sce', 'CONSTANTS', validazioneForm]);

    function getBackendMessage(error, defaultMessage) {
        if (error && error.data) {
            if (error.data.message) {
                return error.data.message;
            }
            if (error.data.messaggio) {
                return error.data.messaggio;
            }
            if (error.data.messages && error.data.messages.length > 0 && error.data.messages[0].message) {
                return error.data.messages[0].message;
            }
        }

        return defaultMessage || "Errore durante la verifica";
    }

    function setBackendFieldError(form, fieldName, errorKey, error, defaultMessage) {
        if (!form || !form[fieldName]) return;

        form[fieldName].$setValidity(errorKey, false);
        form[fieldName].customMessage = getBackendMessage(error, defaultMessage);
    }

    function clearBackendFieldError(form, fieldName, errorKey) {
        if (!form || !form[fieldName]) return;

        form[fieldName].$setValidity(errorKey, true);
        form[fieldName].customMessage = null;
    }

    function pageHeader($sce, CONSTANTS) {
        var urlArgs = CONSTANTS.URL_ARGS;
        return {
            replace: true,
            restrict: 'E',
            scope: {
                imgLogo: '@',
                title: '@',
                backLink: '@',
                infoLink: '@'
            },
            templateUrl: 'resources/html/includes/header.html' + urlArgs
        };
    }

    function pageFooter($sce, CONSTANTS) {
        var urlArgs = CONSTANTS.URL_ARGS;
        return {
            replace: true,
            restrict: 'E',
            templateUrl: 'resources/html/includes/footer.html' + urlArgs
        };
    }

    function richiedente($sce, CONSTANTS, CFService) {
        var urlArgs = CONSTANTS.URL_ARGS;
        return {
            replace: true,
            restrict: 'E',
            templateUrl: 'resources/html/includes/directives/richiedente.html' + urlArgs,
            scope: {
                form: '=',
                data: '='
            },
            controller: ['$scope', '$rootScope', '$log', '$filter', 'MessageService', 'StorageService', 'ResourceService',
                function ($scope, $rootScope, $log, $filter, MessageService, StorageService, ResourceService) {
                    try {
                        $scope.MessageService = MessageService;

                        $scope.$watch('data.codFiscEnte', function (n) {
                            var fieldName = 'richiedente-cf';
                            var errorKey = 'verificaCf'; // 🔥 UNA sola chiave

                            if (!$scope.form || !$scope.form[fieldName]) return;

                            if (n && n.length === 11 && CFService.checkPartitaIva(n)) {

                                ResourceService.codiceFiscale(n).then(function (response) {

                                    var isValid = (response.data === true) || (response.data === 'true');

                                    if (isValid) {
                                        clearBackendFieldError($scope.form, fieldName, errorKey);
                                    } else {
                                        setBackendFieldError(
                                            $scope.form,
                                            fieldName,
                                            errorKey,
                                            null,
                                            "Partita IVA non valida"
                                        );
                                    }

                                }, function (error) {

                                    // 🔥 qui arriva il messaggio backend
                                    setBackendFieldError(
                                        $scope.form,
                                        fieldName,
                                        errorKey,
                                        error,
                                        "Errore nella verifica della partita IVA"
                                    );

                                });

                            } else {
                                clearBackendFieldError($scope.form, fieldName, errorKey);
                            }
                        });

                    } catch (e) {
                        MessageService.addSystemMessages(["Si è verificato un errore"]);
                        MessageService.showMessages();
                        throw e;
                    }
                }]
        };
    }

    function rappresentante($sce, CONSTANTS) {
        var urlArgs = CONSTANTS.URL_ARGS;
        return {
            replace: true,
            restrict: 'E',
            templateUrl: 'resources/html/includes/directives/rappresentante.html' + urlArgs,
            scope: {
                form: '=',
                data: '='
            },
            controller: ['$scope', '$rootScope', '$log', '$filter', 'MessageService', 'StorageService', 'ResourceService',
                function ($scope, $rootScope, $log, $filter, MessageService, StorageService, ResourceService) {
                    try {

                        $scope.MessageService = MessageService;
                        $scope.data.ruoloDelegato = undefined;

                        $scope.verificaCF = function (codiceFiscale) {
                            var fieldName = 'rappresentante-cf';

                            if (codiceFiscale !== undefined && codiceFiscale !== null && codiceFiscale !== '') {
                                ResourceService.verificaCF(codiceFiscale).then(function (response) {

                                    if (!response) {
                                        throw new Error("Impossibile reperire il codice fiscale");
                                    }

                                    $scope.data.cognRl = response.data.cognome;
                                    $scope.data.nomeRl = response.data.nome;

                                    clearBackendFieldError($scope.form, fieldName, 'verificaCf');

                                    // if ($scope.data.codFiscEnte && $scope.data.codFiscRl && $scope.data.cognRl) {
                                    //     var data = '{ "codFiscEnte": "' + $scope.data.codFiscEnte + '","codFiscRl": "' + $scope.data.codFiscRl + '" }';
                                    //     ResourceService.verificaDelega(data).then(function (response) {
                                    //         if (!response) {
                                    //             throw new Error("Impossibile reperire il codice fiscale");
                                    //         }
                                    //         $rootScope.abilitaDelega = response.data.necessitaDelega;
                                    //     }, function (error) {
                                    //         $log.error(error);
                                    //     });
                                    // }

                                }, function (error) {
                                    $scope.data.cognRl = undefined;
                                    $scope.data.nomeRl = undefined;
                                    $log.error(error);

                                    setBackendFieldError(
                                        $scope.form,
                                        fieldName,
                                        'verificaCf',
                                        error,
                                        "Errore nella verifica del codice fiscale"
                                    );
                                });
                            }
                            else {
                                $scope.data.cognRl = undefined;
                                $scope.data.nomeRl = undefined;
                                $rootScope.abilitaDelega = false;

                                clearBackendFieldError($scope.form, fieldName, 'verificaCf');
                            }
                        };

                    } catch (e) {
                        MessageService.addSystemMessages(["Si è verificato un errore"]);
                        MessageService.showMessages();
                        throw e;
                    }
                }]
        };
    }

    function sede($sce, CONSTANTS) {
        var urlArgs = CONSTANTS.URL_ARGS;
        return {
            replace: true,
            restrict: 'E',
            templateUrl: 'resources/html/includes/directives/sede.html' + urlArgs,
            scope: {
                form: '=',
                data: '='
            },
            controller: ['$scope', '$rootScope', '$log', '$filter', 'MessageService', 'StorageService', 'ResourceService',
                function ($scope, $rootScope, $log, $filter, MessageService, StorageService, ResourceService) {
                    try {
                        $scope.MessageService = MessageService;

                        ResourceService.getProvince().then(function (response) {
                            if (response === undefined) {
                                throw new Error("Impossibile prelevare le province");
                            }

                            $scope.listaProvince = response.data.province;
                        }, function (error) {
                            $log.error(error);
                        });

                        $scope.caricaComuni = function (provincia) {
                            $scope.listaComuni = undefined;

                            ResourceService.getComuni(provincia).then(function (response) {
                                if (response === undefined) {
                                    throw new Error("Impossibile prelevare i comuni");
                                }

                                $scope.listaComuni = response.data.comuni;
                            }, function (error) {
                                $log.error(error);
                            });
                        };

                    } catch (e) {
                        MessageService.addSystemMessages(["Si è verificato un errore"]);
                        MessageService.showMessages();
                        throw e;
                    }
                }]
        };
    }

    function delega($sce, CONSTANTS) {
        var urlArgs = CONSTANTS.URL_ARGS;
        return {
            replace: true,
            restrict: 'E',
            templateUrl: 'resources/html/includes/directives/delega.html' + urlArgs,
            scope: {
                form: '=',
                data: '=',
                titolo: '=',
                sottotitolo: '=',
                estensione: '@',
                directupload: '@'
            },
            controller: ['$scope', '$rootScope', '$log', '$filter', '$http', '$window', '$timeout', 'MessageService', 'StorageService', 'ResourceService',
                function ($scope, $rootScope, $log, $filter, $http, $window, $timeout, MessageService, StorageService, ResourceService) {
                    $scope.MessageService = MessageService;
                    $scope.obbligatorio = true;
                    $scope.verificata = false;
                    $scope.scanMessage = true;
                    $scope.errore = undefined;
                    $scope.data.fileDelega = undefined;

                    $scope.enabled = function () {
                        return $rootScope.abilitaDelega;
                    };

                    $scope.fileSelected = function (element) {
                        $scope.obbligatorio = true;
                        $scope.verificata = false;
                        $scope.scanMessage = true;
                        $scope.errore = undefined;
                        $scope.data.fileDelega = undefined;

                        if (element.files[0] !== undefined) {
                            if (element.files[0].name.indexOf($scope.estensione) !== -1) {
                                var reader = new FileReader();
                                reader.readAsDataURL(element.files[0]);
                                $timeout(function () {
                                    $scope.data.fileDelega = btoa(reader.result.split(',')[1]);
                                    $scope.data.fileDelegaNome = element.files[0].name;
                                    $scope.obbligatorio = false;

                                    if ($scope.directupload == 'true' || $scope.directupload == true) {
                                        $scope.errore = undefined;
                                        $scope.verificata = true;
                                        $scope.scanMessage = false;
                                        $scope.$parent.$parent.vm.fileOK = true;
                                    }
                                }, 500);
                            } else {
                                $scope.errore = "File selezionato non valido. Selezionare un file con estensione " + $scope.estensione;
                            }
                        } else {
                            $rootScope.delegaVerificata = false;
                            $scope.verificata = false;
                            $scope.obbligatorio = true;
                            $scope.data.fileDelega = undefined;
                            $scope.disInserimento = true;
                            $scope.disStampa = false;
                            $scope.disInvio = false;
                            $scope.disAnnulla = false;
                        }
                    };
                }]
        };
    }

    function naturaEnte($sce, CONSTANTS) {
        var urlArgs = CONSTANTS.URL_ARGS;
        return {
            replace: true,
            restrict: 'E',
            templateUrl: 'resources/html/includes/directives/natura-ente.html' + urlArgs,
            scope: {
                form: '=',
                data: '=',
                radionaturaente: '='
            },
            controller: ['$scope', '$rootScope', '$log', '$filter', 'MessageService', 'StorageService', 'ResourceService',
                function ($scope, $rootScope, $log, $filter, MessageService, StorageService, ResourceService) {
                    try {
                        $scope.MessageService = MessageService;
                        $scope.abilitaCombo = '1';

                        ResourceService.getTipologie().then(function (response) {
                            if (response === undefined) {
                                throw new Error("Impossibile prelevare le tipologie");
                            }

                            $scope.listaTipologie = response.data.tipologie;
                        }, function (error) {
                            $log.error(error);
                        });

                        $scope.caricaCategorie = function (tipologia) {
                            if (tipologia !== undefined && tipologia !== null) {
                                $scope.listaCategorie = undefined;
                                $scope.listaCategorieSpecifiche = undefined;

                                ResourceService.getCategorie(tipologia).then(function (response) {
                                    if (response === undefined) {
                                        throw new Error("Impossibile prelevare le categorie");
                                    }

                                    $scope.listaCategorie = response.data.categorie;
                                }, function (error) {
                                    $log.error(error);
                                });
                            }
                        };

                        $scope.caricaCategorieSpecifiche = function (tipologia, categoria) {
                            if (categoria !== undefined && categoria !== null) {
                                $scope.listaCategorieSpecifiche = undefined;

                                ResourceService.getCategorieSpecifiche(tipologia, categoria).then(function (response) {
                                    if (response === undefined) {
                                        throw new Error("Impossibile prelevare le categorie specifiche");
                                    }

                                    $scope.listaCategorieSpecifiche = response.data.specCategorie;
                                }, function (error) {
                                    $log.error(error);
                                });
                            }
                        };

                        $scope.resetValori = function (valoreCombo) {
                            $scope.radionaturaente = angular.copy(valoreCombo);

                            if (valoreCombo == 2) {
                                $scope.listaTipologie = undefined;
                                $scope.listaCategorie = undefined;
                                $scope.listaCategorieSpecifiche = undefined;
                            } else {
                                ResourceService.getTipologie().then(function (response) {
                                    if (response === undefined) {
                                        throw new Error("Impossibile prelevare le tipologie");
                                    }

                                    $scope.listaTipologie = response.data.tipologie;
                                }, function (error) {
                                    $log.error(error);
                                });
                            }
                        };

                    } catch (e) {
                        MessageService.addSystemMessages(["Si è verificato un errore"]);
                        MessageService.showMessages();
                        throw e;
                    }
                }]
        };
    }

    function normeLegittimanti($sce, CONSTANTS) {
        var urlArgs = CONSTANTS.URL_ARGS;
        return {
            replace: true,
            restrict: 'E',
            templateUrl: 'resources/html/includes/directives/norme-legittimanti.html' + urlArgs,
            scope: {
                form: '=',
                data: '=',
                radionaturaente: '='
            },
            controller: ['$scope', '$rootScope', '$log', '$filter', 'MessageService', 'StorageService', 'ResourceService',
                function ($scope, $rootScope, $log, $filter, MessageService, StorageService, ResourceService) {
                    try {
                        $scope.MessageService = MessageService;

                        $scope.verificaRequired = function (obj) {
                            $scope.normeRequired = true;

                            if ($scope.radionaturaente == 1) {
                                if (obj.codTipologia == 1) {
                                    if (obj.codCategoria == 33) {
                                        if (obj.codSpecCat == 74 || obj.codSpecCat == 73) {
                                            $scope.normeRequired = false;
                                        }
                                    }
                                    else if (obj.codCategoria == 27) {
                                        if (obj.codSpecCat == 177 || obj.codSpecCat == 59) {
                                            $scope.normeRequired = false;
                                        }
                                    }
                                    else if (obj.codCategoria == 29) {
                                        if (obj.codSpecCat == 62 || obj.codSpecCat == 63) {
                                            $scope.normeRequired = false;
                                        }
                                    }
                                    else if (obj.codCategoria == 13) {
                                        if (obj.codSpecCat == 25) {
                                            $scope.normeRequired = false;
                                        }
                                    }
                                    else if (obj.codCategoria == 4) {
                                        if (obj.codSpecCat == 4) {
                                            $scope.normeRequired = false;
                                        }
                                    }
                                } else if (obj.codTipologia == 5) {
                                    if (obj.codCategoria == 64) {
                                        if (obj.codSpecCat == 140 || obj.codSpecCat == 141) {
                                            $scope.normeRequired = false;
                                        }
                                    }
                                    if (obj.codCategoria == 68) {
                                        if (obj.codSpecCat == 146) {
                                            $scope.normeRequired = false;
                                        }
                                    }
                                }
                                else if (obj.codTipologia == 2) {
                                    if (obj.codCategoria == 34 && obj.codSpecCat == 75) {
                                        $scope.normeRequired = false;
                                    }
                                }
                                else if (obj.codTipologia == 4) {
                                    if (obj.codCategoria == 38 && obj.codSpecCat == 91) {
                                        $scope.normeRequired = false;
                                    }
                                }
                            }
                            return $scope.normeRequired;
                        };

                        $scope.verificaReadOnly = function (obj) {
                            $scope.normeReadOnly = false;

                            if ($scope.radionaturaente == 1) {
                                if (obj.codTipologia == 1) {
                                    if (obj.codCategoria == 33) {
                                        if (obj.codSpecCat == 74 || obj.codSpecCat == 73) {
                                            $scope.normeReadOnly = true;
                                        }
                                    }
                                    else if (obj.codCategoria == 27) {
                                        if (obj.codSpecCat == 177 || obj.codSpecCat == 59) {
                                            $scope.normeReadOnly = true;
                                        }
                                    }
                                    else if (obj.codCategoria == 29) {
                                        if (obj.codSpecCat == 62 || obj.codSpecCat == 63) {
                                            $scope.normeReadOnly = true;
                                        }
                                    }
                                    else if (obj.codCategoria == 13) {
                                        if (obj.codSpecCat == 25) {
                                            $scope.normeReadOnly = true;
                                        }
                                    }
                                    else if (obj.codCategoria == 4) {
                                        if (obj.codSpecCat == 4) {
                                            $scope.normeReadOnly = true;
                                        }
                                    }
                                } else if (obj.codTipologia == 5) {
                                    if (obj.codCategoria == 64) {
                                        if (obj.codSpecCat == 140 || obj.codSpecCat == 141) {
                                            $scope.normeReadOnly = true;
                                        }
                                    }
                                    if (obj.codCategoria == 68) {
                                        if (obj.codSpecCat == 146) {
                                            $scope.normeReadOnly = true;
                                        }
                                    }
                                }
                                else if (obj.codTipologia == 2) {
                                    if (obj.codCategoria == 34 && obj.codSpecCat == 75) {
                                        $scope.normeReadOnly = true;
                                    }
                                }
                                else if (obj.codTipologia == 4) {
                                    if (obj.codCategoria == 38 && obj.codSpecCat == 91) {
                                        $scope.normeReadOnly = true;
                                    }
                                }
                            }
                            return $scope.normeReadOnly;
                        };

                    } catch (e) {
                        MessageService.addSystemMessages(["Si è verificato un errore"]);
                        MessageService.showMessages();
                        throw e;
                    }
                }]
        };
    }

    function responsabileConvenzione($sce, CONSTANTS) {
        var urlArgs = CONSTANTS.URL_ARGS;
        return {
            replace: true,
            restrict: 'E',
            templateUrl: 'resources/html/includes/directives/responsabile-convenzione.html' + urlArgs,
            scope: {
                form: '=',
                data: '='
            },
            controller: ['$scope', '$rootScope', '$log', '$filter', 'MessageService', 'StorageService', 'ResourceService',
                function ($scope, $rootScope, $log, $filter, MessageService, StorageService, ResourceService) {
                    try {
                        $scope.MessageService = MessageService;
                        $scope.callVerificaDelega = false;

                        $rootScope.$on('reset', function (event, data) {
                            console.log(data);
                        });

                        $scope.verificaCF = function (codiceFiscale) {
                            var fieldName = 'responsabile-cf';

                            if (codiceFiscale !== undefined && codiceFiscale !== null && codiceFiscale !== '') {
                                ResourceService.verificaCF(codiceFiscale).then(function (response) {
                                    if (!response) {
                                        throw new Error("Impossibile reperire il codice fiscale");
                                    }

                                    $scope.data.cognRefAbilitato = response.data.cognome;
                                    $scope.data.nomeRefAbilitato = response.data.nome;

                                    clearBackendFieldError($scope.form, fieldName, 'verificaCf');

                                }, function (error) {
                                    $scope.data.cognRefAbilitato = undefined;
                                    $scope.data.nomeRefAbilitato = undefined;
                                    $log.error(error);

                                    setBackendFieldError(
                                        $scope.form,
                                        fieldName,
                                        'verificaCf',
                                        error,
                                        "Errore nella verifica del codice fiscale"
                                    );
                                });
                            } else {
                                $scope.data.cognRefAbilitato = undefined;
                                $scope.data.nomeRefAbilitato = undefined;

                                clearBackendFieldError($scope.form, fieldName, 'verificaCf');
                            }
                        };

                    } catch (e) {
                        MessageService.addSystemMessages(["Si è verificato un errore"]);
                        MessageService.showMessages();
                        throw e;
                    }
                }]
        };
    }

    function ricerca($sce, CONSTANTS) {
        var urlArgs = CONSTANTS.URL_ARGS;
        return {
            replace: true,
            restrict: 'E',
            templateUrl: 'resources/html/includes/directives/ricerca.html' + urlArgs,
            scope: {
                form: '=',
                data: '=',
                fieldsetlegend: '@'
            },
            controller: ['$scope', '$rootScope', '$log', '$filter', 'MessageService', 'StorageService', 'ResourceService',
                function ($scope, $rootScope, $log, $filter, MessageService, StorageService, ResourceService) {
                    try {
                        $scope.MessageService = MessageService;
                    } catch (e) {
                        MessageService.addSystemMessages(["Si è verificato un errore"]);
                        MessageService.showMessages();
                        throw e;
                    }
                }]
        };
    }

    function variazioneDati($sce, CONSTANTS) {
        var urlArgs = CONSTANTS.URL_ARGS;
        return {
            replace: true,
            restrict: 'E',
            templateUrl: 'resources/html/includes/directives/variazione-dati.html' + urlArgs,
            scope: {
                form: '=',
                data: '=',
                datioriginali: '=',
                variazione: '='
            },
            controller: ['$scope', '$rootScope', '$log', '$filter', '$http', '$window', '$timeout', 'MessageService', 'StorageService', 'ResourceService',
                function ($scope, $rootScope, $log, $filter, $http, $window, $timeout, MessageService, StorageService, ResourceService) {
                    try {

                        $scope.inputCaptcha = "";
                        $scope.MessageService = MessageService;
                        $scope.datiIniziali = angular.copy($scope.data);
                        $scope.variazioneSalvata = false;
                        $scope.operazione = undefined;
                        $scope.data.flagRdC = false;
                        $scope.data.flagRL = false;
                        $scope.data.flagSD = false;
                        $scope.data.flagSV = false;
                        $scope.data.flagCO = false;

                        var fieldNameByRuolo = {
                            'responsabile': 'responsabile-cf',
                            'rappresentante': 'rappresentante-cf',
                            'responsabile-sd': 'responsabile-sd-cf',
                            'supervisore': 'supervisore-cf',
                            'coordinatore': 'coordinatore-cf'
                        };

                        function clearDatiRuolo(ruolo) {
                            if (ruolo == 'responsabile') {
                                $scope.data.cognRespConvEnte = undefined;
                                $scope.data.nomeRespConvEnte = undefined;
                                $scope.data.emailRespConvEnte = undefined;
                                $scope.data.telRespConvEnte = undefined;
                                $scope.data.faxRespConvEnte = undefined;
                                $scope.data.emailContattoRef = undefined;
                            }
                            else if (ruolo == 'rappresentante') {
                                $scope.data.cognTitConvEnte = undefined;
                                $scope.data.nomeTitConvEnte = undefined;
                                $scope.data.emailTitConvEnte = undefined;
                                $scope.data.telTitConvEnte = undefined;
                                $scope.data.faxTitConvEnte = undefined;
                                $scope.data.titoloTitConvEnte = undefined;
                                $scope.data.ruoloTitConvEnte = undefined;
                                $scope.data.ruoloDelegato = undefined;
                            }
                            else if (ruolo == 'responsabile-sd') {
                                $scope.data.cognRespScDatiEnte = undefined;
                                $scope.data.nomeRespScDatiEnte = undefined;
                                $scope.data.emailRespScDatiEnte = undefined;
                                $scope.data.telRespScDatiEnte = undefined;
                                $scope.data.faxRespScDatiEnte = undefined;
                            }
                            else if (ruolo == 'supervisore') {
                                $scope.data.cognSVEnte = undefined;
                                $scope.data.nomeSVEnte = undefined;
                                $scope.data.emailSVEnte = undefined;
                                $scope.data.telSVEnte = undefined;
                                $scope.data.faxSVEnte = undefined;
                            }
                            else if (ruolo == 'coordinatore') {
                                $scope.data.cognRespCoordEnte = undefined;
                                $scope.data.nomeRespCoordEnte = undefined;
                                $scope.data.emailRespCoordEnte = undefined;
                                $scope.data.telRespCoordEnte = undefined;
                                $scope.data.faxRespCoordEnte = undefined;
                            }
                        }

                        $scope.initFn = function (loadImg) {
                            $scope.reloadCaptcha = loadImg;
                        };

                        $scope.actionDisabled = function () {
                            return $scope.form.$invalid;
                        };

                        $scope.openConfirm = function (operazione) {
                            $scope.operazione = operazione;
                            angular.element("#modal-conferma").modal('show');
                        };

                        $scope.conferma = function () {
                            angular.element("#modal-conferma").modal('hide');

                            $timeout(function () {
                                if ($scope.operazione == 'salvare') {
                                    $scope.salva();
                                } else {
                                    $scope.valida();
                                }
                            }, 500);
                        };

                        $scope.salva = function () {
                            $window.scroll(0, 0);
                            var data = $scope.data;
                            data.azione = 'salva';
                            data.infoMessage = undefined;
                            $scope.variazione = false;

                            ResourceService.variazioneSalva(data, $scope.inputCaptcha).then(function (response) {
                                $scope.variazioneSalvata = true;
                                $scope.variazione = true;
                                $scope.infoMessage = response.data.infoMessage;
                                MessageService.clearMessages();

                                var message = {};
                                message.severity = 'SUCCESS';
                                message.message = 'Operazione effettuata con successo.';
                                MessageService.setMessages([message]);
                                MessageService.showMessages();
                                $scope.reloadCaptcha();

                            }, function (response) {
                                $log.error(response);
                                $scope.variazioneSalvata = false;
                                $scope.variazione = false;
                                response.data.messages[0].severity = 'ERROR';
                                MessageService.setMessages(response.data.messages);
                                MessageService.showMessages();
                                $scope.reloadCaptcha();
                            });
                        };

                        $scope.valida = function () {
                            $window.scroll(0, 0);
                            var data = $scope.data;
                            data.azione = 'valida';
                            data.infoMessage = undefined;

                            ResourceService.variazioneSalva(data, $scope.inputCaptcha).then(function (response) {
                                MessageService.clearMessages();

                                if (response.data.delega) {
                                    $scope.$parent.$parent.vm.abilitaDelegaVariazione = true;
                                    $scope.$parent.$parent.vm.variazioneClicked = false;
                                    $rootScope.abilitaDelega = true;
                                }
                                else {
                                    $scope.$parent.$parent.vm.abilitaDelegaVariazione = false;
                                    $scope.$parent.$parent.vm.variazioneClicked = false;
                                    $scope.$parent.$parent.vm.pulsantiVisibili = true;
                                    $rootScope.abilitaDelega = false;
                                    $scope.$parent.$parent.vm.datiInvio = response.data;
                                    $scope.$parent.$parent.vm.datiInvio.infoMessage = undefined;
                                    $scope.$parent.$parent.vm.disabilitato = response.data.statoRichiesta == "-1" || response.data.statoRichiesta == "0";

                                    $scope.$parent.$parent.vm.disInserimento = true;
                                    $scope.$parent.$parent.vm.disStampa = true;
                                    $scope.$parent.$parent.vm.disInvio = true;
                                    $scope.$parent.$parent.vm.disAnnulla = true;

                                    if (response.data.statoRichiesta == '1') {
                                        $scope.$parent.$parent.vm.disStampa = false;
                                        $scope.$parent.$parent.vm.disInvio = false;
                                        $scope.$parent.$parent.vm.disAnnulla = false;
                                    } else if (response.data.statoRichiesta == '-1' || response.data.statoRichiesta == '0' || response.data.statoRichiesta == '3' || response.data.statoRichiesta >= '5') {
                                        $scope.$parent.$parent.vm.disInserimento = false;
                                    } else if (response.data.statoRichiesta == '2' || response.data.statoRichiesta == '4') {
                                        $scope.$parent.$parent.vm.disStampa = false;
                                    }

                                    var message = {};
                                    message.severity = 'SUCCESS';
                                    message.message = 'Operazione di acquisizione dei dati correttamente effettuata. Cliccando sul Pulsante "Scarica Pdf Richiesta" il sistema genera un file in formato "Pdf" che riepiloga tutte le informazioni inserite. Tale file viene spedito anche all’indirizzo email nominale del Responsabile di Convenzione indicato e, dopo essere stato sottoscritto digitalmente a cura del Rappresentante legale dell\'Ente, deve essere inviato all\'Agenzia attraverso l\'apposito tasto denominato "invio richiesta" entro 30 giorni dalla generazione del file altrimenti la richiesta verrà automaticamente cancellata. È possibile annullare la richiesta di modifica pendente prima del definitivo invio attraverso il tasto "Annulla Richiesta di Modifica". In questo modo sarà possibile ripresentare una nuova richiesta d\'aggiornamento.';
                                    MessageService.setMessages([message]);
                                    MessageService.showMessages();
                                    $scope.reloadCaptcha();
                                }

                                $scope.$parent.$parent.vm.variazione = false;

                            }, function (response) {
                                $log.error(response);
                                $scope.variazioneSalvata = false;
                                $rootScope.abilitaDelega = false;
                                $scope.$parent.$parent.vm.abilitaDelegaVariazione = false;
                                response.data.messages[0].severity = 'ERROR';
                                MessageService.setMessages(response.data.messages);
                                MessageService.showMessages();
                                $scope.reloadCaptcha();
                            });
                        };

                        $scope.indietro = function () {
                            $scope.$parent.$parent.vm.pulsantiVisibili = true;
                            $scope.$parent.$parent.vm.variazioneClicked = false;
                            $scope.$parent.$parent.vm.variazione = $scope.variazione;

                            var data = {
                                cfEnte: $scope.$parent.$parent.vm.datiInvio.cfEnte,
                                protocolloRichiesta: $scope.$parent.$parent.vm.datiInvio.protocolloRichiesta
                            };
                            var captcha = $window.sessionStorage.getItem("captcha");

                            ResourceService.controlloVariazioneSalvata(data, captcha).then(
                                function (response) {
                                    if (response.data) {
                                        var message = {};
                                        message.severity = 'SUCCESS';
                                        message.message = 'Esiste una richiesta salvata da validare';
                                        MessageService.setMessages([message]);
                                        MessageService.showMessages();
                                    }
                                    $window.scroll(0, 0);
                                }, function (response) {
                                    $log.error(response);
                                    $scope.$parent.$parent.vm.pulsantiVisibili = true;
                                    $scope.$parent.$parent.vm.annullaClicked = false;
                                    response.data.messages[0].severity = 'ERROR';
                                    MessageService.setMessages(response.data.messages);
                                    MessageService.showMessages();
                                }
                            );
                        };

                        $scope.verificaCF = function (codiceFiscale, ruolo) {
                            var fieldName = fieldNameByRuolo[ruolo];

                            if (codiceFiscale !== undefined && codiceFiscale !== "") {
                                ResourceService.verificaCF(codiceFiscale).then(function (response) {

                                    if (!response) {
                                        throw new Error("Impossibile reperire il codice fiscale");
                                    }

                                    clearBackendFieldError($scope.form, fieldName, 'verificaCf');

                                    if (ruolo == 'responsabile') {
                                        if (codiceFiscale != $scope.datiIniziali.cfRespConvEnte) {
                                            $scope.data.flagRdC = true;
                                        }
                                        $scope.data.cognRespConvEnte = response.data.cognome;
                                        $scope.data.nomeRespConvEnte = response.data.nome;
                                        $scope.data.emailRespConvEnte = undefined;
                                        $scope.data.telRespConvEnte = undefined;
                                        $scope.data.faxRespConvEnte = undefined;
                                        $scope.data.emailContattoRef = undefined;

                                    }
                                    else if (ruolo == 'rappresentante') {
                                        if (codiceFiscale != $scope.datiIniziali.cfTitConvEnte) {
                                            $scope.data.flagRL = true;
                                        }
                                        $scope.data.cognTitConvEnte = response.data.cognome;
                                        $scope.data.nomeTitConvEnte = response.data.nome;
                                        $scope.data.emailTitConvEnte = undefined;
                                        $scope.data.telTitConvEnte = undefined;
                                        $scope.data.faxTitConvEnte = undefined;
                                        $scope.data.titoloTitConvEnte = undefined;
                                        $scope.data.ruoloTitConvEnte = undefined;
                                    }
                                    else if (ruolo == 'responsabile-sd') {
                                        if (codiceFiscale != $scope.datiIniziali.cfRespScDatiEnte) {
                                            $scope.data.flagSD = true;
                                        }
                                        $scope.data.cognRespScDatiEnte = response.data.cognome;
                                        $scope.data.nomeRespScDatiEnte = response.data.nome;
                                        $scope.data.emailRespScDatiEnte = undefined;
                                        $scope.data.telRespScDatiEnte = undefined;
                                        $scope.data.faxRespScDatiEnte = undefined;
                                    }
                                    else if (ruolo == 'supervisore') {
                                        if (codiceFiscale != $scope.datiIniziali.cfSVEnte) {
                                            $scope.data.flagSV = true;
                                        }
                                        $scope.data.cognSVEnte = response.data.cognome;
                                        $scope.data.nomeSVEnte = response.data.nome;
                                        $scope.data.emailSVEnte = undefined;
                                        $scope.data.telSVEnte = undefined;
                                        $scope.data.faxSVEnte = undefined;
                                    }
                                    else if (ruolo == 'coordinatore') {
                                        if (codiceFiscale != $scope.datiIniziali.cfRespCoordEnte) {
                                            $scope.data.flagCO = true;
                                        }
                                        $scope.data.cognRespCoordEnte = response.data.cognome;
                                        $scope.data.nomeRespCoordEnte = response.data.nome;
                                        $scope.data.emailRespCoordEnte = undefined;
                                        $scope.data.telRespCoordEnte = undefined;
                                        $scope.data.faxRespCoordEnte = undefined;
                                    }

                                }, function (error) {
                                    $log.error(error);

                                    setBackendFieldError(
                                        $scope.form,
                                        fieldName,
                                        'verificaCf',
                                        error,
                                        "Errore nella verifica del codice fiscale"
                                    );

                                    clearDatiRuolo(ruolo);
                                });
                            }
                            else {
                                clearBackendFieldError($scope.form, fieldName, 'verificaCf');
                                clearDatiRuolo(ruolo);
                            }
                        };

                    } catch (e) {
                        MessageService.addSystemMessages(["Si è verificato un errore"]);
                        MessageService.showMessages();
                        throw e;
                    }
                }]
        };
    }

    function scaricaPdfRichiesta($sce, CONSTANTS) {
        var urlArgs = CONSTANTS.URL_ARGS;
        return {
            replace: true,
            restrict: 'E',
            templateUrl: 'resources/html/includes/directives/scarica-pdf-richiesta.html' + urlArgs,
            scope: {
                form: '=',
                data: '='
            },
            controller: ['$scope', '$rootScope', '$log', '$filter', '$http', '$window', '$timeout', 'MessageService', 'StorageService', 'ResourceService',
                function ($scope, $rootScope, $log, $filter, $http, $window, $timeout, MessageService, StorageService, ResourceService) {
                    try {
                        $scope.MessageService = MessageService;
                        $scope.inputCaptcha = "";

                        $scope.initFn = function (loadImg) {
                            $scope.reloadCaptcha = loadImg;
                        };

                        $scope.indietro = function () {
                            $scope.$parent.$parent.vm.pulsantiVisibili = true;
                            $scope.$parent.$parent.vm.pdfClicked = false;
                            MessageService.clearMessages();
                        };

                        $scope.scaricaPDF = function () {
                            const headerDict = {
                                "X-Content-Type-Options": "nosniff",
                                "X-XSS-Protection": "1; mode=block",
                                "X-Frame-Options": "deny",
                                "Strict-Transport-Security": "max-age=16070400; includeSubDomains",
                                "Cache-Control": "no-cache,no-store, must-revalidate, pre-check=0, post-check=0"
                            };
                            var method = 'POST';
                            var data = '{ "cfEnte": "' + $scope.data.cfEnte + '", "protocolloRichiesta": "' + $scope.data.protocolloRichiesta + '" }';

                            $http({
                                url: CONSTANTS.CONTEXT_REST_SERVICE + 'richiesta/variazione/download?input-captcha=' + $scope.inputCaptcha,
                                method: method,
                                responseType: 'arraybuffer',
                                headers: headerDict,
                                data: data
                            }).then(function (result) {
                                try {
                                    var headers = result.headers();
                                    var contentType = headers['content-type'];
                                    var fileNamePattern = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                                    var fileName = fileNamePattern.exec(headers['content-disposition'])[1];
                                    var blob = new Blob([result.data], { type: contentType });

                                    fileSaver.saveAs(blob, fileName);
                                    $window.sessionStorage.setItem("captcha", $scope.inputCaptcha);
                                    $scope.reloadCaptcha();

                                } catch (e) {
                                    var msgArray = [{ severity: 'ERROR', message: 'Errore nella stampa della domanda' }];
                                    MessageService.setMessages(msgArray);
                                    MessageService.showMessages();
                                    $scope.reloadCaptcha();
                                }

                            }, function error(data) {
                                $log.error(data);
                                var msgArray = [{ severity: 'ERROR', message: data.headers('msg') }];
                                MessageService.setMessages(msgArray);
                                MessageService.showMessages();
                                $scope.reloadCaptcha();
                            });
                        };

                    } catch (e) {
                        MessageService.addSystemMessages(["Si è verificato un errore"]);
                        MessageService.showMessages();
                        throw e;
                    }
                }]
        };
    }

    function annullaRichiestaVariazione($sce, CONSTANTS) {
        var urlArgs = CONSTANTS.URL_ARGS;
        return {
            replace: true,
            restrict: 'E',
            templateUrl: 'resources/html/includes/directives/annulla-richiesta-variazione.html' + urlArgs,
            scope: {
                form: '=',
                data: '=',
                annulla: '='
            },
            controller: ['$scope', '$rootScope', '$log', '$filter', '$http', '$window', '$timeout', 'MessageService', 'StorageService', 'ResourceService',
                function ($scope, $rootScope, $log, $filter, $http, $window, $timeout, MessageService, StorageService, ResourceService) {
                    try {

                        MessageService.clearMessages();
                        $scope.MessageService = MessageService;
                        $scope.inputCaptcha = "";

                        $scope.initFn = function (loadImg) {
                            $scope.reloadCaptcha = loadImg;
                        };

                        $scope.openConfirm = function () {
                            angular.element("#modal-conferma").modal('show');
                        };

                        $scope.conferma = function () {
                            angular.element("#modal-conferma").modal('hide');

                            $timeout(function () {
                                $scope.confermaInner();
                            }, 500);
                        };

                        $scope.indietro = function () {
                            $scope.$parent.$parent.vm.pulsantiVisibili = true;
                            $scope.$parent.$parent.vm.annullaClicked = false;
                        };

                        $scope.confermaInner = function () {
                            angular.element("#modal-conferma").modal('hide');
                            var data = $scope.annulla;
                            data.azione = "annulla";

                            ResourceService.variazioneAnnulla(data, $scope.inputCaptcha).then(
                                function (response) {
                                    $scope.$parent.$parent.vm.annullaClicked = false;
                                    $scope.$parent.$parent.vm.pulsantiVisibili = true;
                                    $scope.$parent.$parent.vm.datiInvio = response.data;
                                    $scope.$parent.$parent.vm.disabilitato = true;

                                    $scope.$parent.$parent.vm.disInserimento = false;
                                    $scope.$parent.$parent.vm.disStampa = true;
                                    $scope.$parent.$parent.vm.disInvio = true;
                                    $scope.$parent.$parent.vm.disAnnulla = true;

                                    MessageService.clearMessages();
                                    var message = {};
                                    message.severity = 'SUCCESS';
                                    message.message = angular.copy(response.data.infoMessage);
                                    MessageService.setMessages([message]);
                                    MessageService.showMessages();
                                    $scope.reloadCaptcha();

                                }, function (response) {
                                    $log.error(response);
                                    $scope.$parent.$parent.vm.annullaClicked = true;
                                    $scope.$parent.$parent.vm.pulsantiVisibili = false;
                                    response.data.messages[0].severity = 'ERROR';
                                    MessageService.setMessages(response.data.messages);
                                    MessageService.showMessages();
                                    $scope.reloadCaptcha();
                                });
                        };

                    } catch (e) {
                        MessageService.addSystemMessages(["Si è verificato un errore"]);
                        MessageService.showMessages();
                        throw e;
                    }
                }]
        };
    }

    function fieldValidation($sce, CONSTANTS) {
        var urlArgs = CONSTANTS.URL_ARGS;
        return {
            replace: true,
            restrict: 'E',
            templateUrl: 'resources/html/includes/directives/field-validation.html' + urlArgs,
            scope: {
                form: '=',
                key: '@',
                addon: '@'
            },
            controller: ['$scope', '$rootScope', '$log', 'MessageService', 'ResourceService', 'StorageService', 'ErrorService',
                function ($scope, $rootScope, $log, MessageService, ResourceService, StorageService, ErrorService) {

                    $scope.MessageService = MessageService;

                    $scope.getErrore = function () {
                        var field = $scope.form[$scope.key];

                        if (!field) return;

                        if (field.customMessage) {
                            return field.customMessage;
                        }

                        return ErrorService.getErrore(field.$error);
                    };

                }]
        };
    }

    function validazioneForm($sce, CONSTANTS) {
        var urlArgs = CONSTANTS.URL_ARGS;
        return {
            replace: true,
            restrict: 'E',
            templateUrl: 'resources/html/includes/directives/validazione-form.html' + urlArgs,
            scope: {
                form: '='
            },
            controller: ['$scope', '$rootScope', '$log', 'MessageService', 'ResourceService', 'StorageService', 'ErrorService',
                function ($scope, $rootScope, $log, MessageService, ResourceService, StorageService, ErrorService) {
                    $scope.show = false;
                    $scope.MessageService = MessageService;

                    $scope.getErrore = function (errore, field) {
                        if (field && field.customMessage) {
                            return field.customMessage;
                        }
                        return ErrorService.getErrore(errore);
                    };

                    $scope.mostraSegnalazioni = function () {
                        $scope.show = !$scope.show;
                    };
                }]
        };
    }

    return pageDirectives;
});


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/resources/js/app/directives/page-directives.js
// module id = 39
// module chunks = 1